<template>
  <b-container fluid>
    <b-breadcrumb style="background-color: #f8f9fa">
      <b-breadcrumb-item to="/dashboard">
        <b-icon
          icon="house-fill"
          scale="1.25"
          shift-v="1.25"
          aria-hidden="true"
        />&nbsp;{{$t("dashboard")}}
      </b-breadcrumb-item>
      <b-breadcrumb-item active>{{$t("complaints.myComplaints")}}</b-breadcrumb-item>
    </b-breadcrumb>
    <b-overlay
      :show="isLoading"
      rounded="sm"
    >
      <b-card
        no-body
        class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0"
      >
        <b-navbar
          class="background-white"
          toggleable="lg"
        >
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
          <b-navbar-brand
            href="#"
            class="text-dark"
          >
            <strong>{{$t("complaints.myComplaints")}}</strong>
          </b-navbar-brand>

          <b-collapse
            id="nav-collapse"
            is-nav
          >
            <b-navbar-nav class="ml-auto">
              <b-nav-form>
                <b-button
                  @click="openComplaintFormPage"
                  class="my-2 my-sm-0 mr-2"
                  variant="outline-primary"
                  size="sm"
                >
                  {{$t("complaints.addComplaint")}}
                </b-button>
                <b-button
                  variant="outline-info"
                  size="sm"
                  class="mr-2"
                  @click="reloadTable"
                >
                  {{$t("remingtonSeed.reload")}}
                </b-button>
                <b-form-group>
                  <b-input-group size="sm">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      :placeholder="$t('remingtonSeed.search')"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        :disabled="!filter"
                        @click="filter = ''"
                      >{{$t("remingtonSeed.clear")}}</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-nav-form>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
        <b-table
          class="main-table"
          hover
          striped
          sticky-header="calc(100vh - 395px)"
          fixed
          :busy.sync="isLoading"
          ref="table"
          id="employee-complaints-table"
          :fields="staticFields"
          :items="getComplaintsTableData"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          responsive="sm"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          no-sort-reset
        >
          <template v-slot:cell(created_at)="data">
            <p>{{ createdAtDate(data.item.created_at) }}</p>
          </template>
          <template v-slot:cell(type)="data">
            <p>{{JSON.parse(data.item.form_title)[selectedLangauge] || $t(data.item.type)}}</p>
          </template>
          <template v-slot:cell(status)="data">
            <b-badge
              v-if="data.item.status == 1"
              variant="info"
            >{{$t("remingtonSeed.Open")}}</b-badge>
            <b-badge
              v-else-if="data.item.status == 2"
              variant="success"
            >{{$t("remingtonSeed.Closed")}}</b-badge>
            <b-badge
              v-else-if="data.item.status == 3"
              variant="warning"
            >{{$t("remingtonSeed.onHold")}}</b-badge>
            <font-awesome-icon v-if="parseInt(data.item.complaint_files_count) > 0" class="ml-2" icon="paperclip" />
          </template>
        </b-table>
        <template v-slot:footer>
          <b-row>
            <b-col cols="2">
              <b-form-select
                v-model="perPage"
                id="perPageSelect"
                size="sm"
                :options="pageOptions"
              ></b-form-select>
            </b-col>
            <b-col cols="6">
              <p class="text-center">
                {{$t("remingtonSeed.showingResults")}}
                <b>{{fromRows}}</b> {{$t("remingtonSeed.to")}}
                <b>{{toRows}}</b>
              </p>
            </b-col>
            <b-col cols="4">
              <b-pagination
                class="float-right"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                :first-text="$t('remingtonSeed.first')"
                :prev-text="$t('remingtonSeed.prev')"
                :next-text="$t('remingtonSeed.next')"
                :last-text="$t('remingtonSeed.last')"
                aria-controls="employee-complaints-table"
              ></b-pagination>
            </b-col>
          </b-row>
        </template>
      </b-card>
    </b-overlay>
  </b-container>
</template>
<script>
import { HTTP } from "../../../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
export default {
  name: "MyComplaintsTab",
  data () {
    return {
      selectedLangauge: 'english',
      showAddCommentModal: false,
      submiting: false,
      isLoading: false,
      responseSuccess: false,
      totalRows: 0,
      filter: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      createdAt: null,
      comment: null,
      type: null,
      status: null,
      staticFields: [],
      fromRows: 0,
      toRows: 0,
    };
  },
  created () {
    // console.log(this.createdAt, "here");
  },
  computed: {
    rows () {
      return this.totalRows;
    },
  },
  mounted () {
    this.selectedLangauge = localStorage.getItem( "formDefaultLanguage" );
    this.staticFields =  [
      { key: "created_at", label: this.$t("remingtonSeed.dateFiled") , sortable: true },
      // { key: "title", label: "Title", sortable: true },
      { key: "comment", label: this.$t("remingtonSeed.comment"), sortable: true },
      { key: "type", label: this.$t("remingtonSeed.type"), sortable: true },
      { key: "status", label: this.$t("remingtonSeed.status"), sortable: true },
    ]
  },
  methods: {
    openComplaintFormPage () {
      this.$router.push( "/add-complaint" );
    },
    createdAtDate ( value ) {
      moment.locale( "en" );
      return moment( value ).format( "DD/MM/YYYY" );
    },
    reloadTable () {
      this.$root.$emit( "bv::refresh::table", "employee-complaints-table" );
    },
    async getComplaintsTableData () {
      let userId = localStorage.getItem( "userId" );
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + ( this.sortDesc == true ? "desc" : "asc" ),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      let response = await HTTP(
        "post",
        "api/v1/complaints/get/table/" + userId,
        formData,
        {
          Authorization: token,
        }
      );

      try {
        this.isLoading = false;
        this.fromRows = response.data.from || 0;
        this.toRows = response.data.to || 0;
        this.totalRows = response.data.total;
        this.$store.state.employeeDashboardComplaintsLazyLoad = false;
        return response.data.data;
      } catch ( err ) {
        this.isLoading = false;

        return [err];
      } finally {
        this.isLoading = false;
      }
    },
  },
  props: {
    managerDashboard: Boolean,
  },
};
</script>